import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";

@Component({
  selector: 'app-total-capital',
  standalone: true,
  imports: [
    CommonModule,
  ],
  templateUrl: './total-capital.component.html',
  styleUrls: ['./total-capital.component.scss']
})
export class TotalCapitalComponent implements OnInit {
  @Input() totalCapitalValue: number = 0;
  @Input() capitalName: string = 'Total Capital:';

  get totalPercent(): number {
    if (this.totalCapitalValue === 100) return 0;
    return +(100 - Number((this.totalCapitalValue * 100).toFixed(2))).toFixed(2);
  }

  constructor() { }

  ngOnInit(): void {
  }

}
